import { useEffect } from 'react';
import { useApiContext, useGetDepositMethods } from 'react-easyrocket';

export function useInitDepositMethods() {
  const { refetch } = useGetDepositMethods({ enabled: false });
  const { isAuthenticated } = useApiContext();

  useEffect(() => {
    isAuthenticated && refetch();
  }, [isAuthenticated]);
}
